import { render, staticRenderFns } from "./GeneralSettingsScrollToTop.vue?vue&type=template&id=13b0fc19&scoped=true&"
import script from "./GeneralSettingsScrollToTop.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingsScrollToTop.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettingsScrollToTop.vue?vue&type=style&index=0&id=13b0fc19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b0fc19",
  null
  
)

export default component.exports